import { createSvgComponent } from "../../icon/createSvgComponent";
import SituationPolicy from "@core/icon/assets/situation-policy.svg";
export default createSvgComponent(SituationPolicy);